<template>
  <div>
    <div class="text-xs-right">
      <v-btn color="grey" dark @click="showHistory = true"> ประวัติผู้โชคดี </v-btn>
    </div>
    <div class="headline primary--text mb-3">
      <v-icon color="primary">people</v-icon> ลูกค้าผู้โชคดี
    </div>

    <multiselect
      v-validate="'required'"
      name="customer"
      v-model="selectCustomer"
      :options="customers"
      :searchable="true"
      :close-on-select="true"
      :show-labels="false"
      placeholder="ระบุชื่อลูกค้า"
      :loading="loading"
      :internal-search="false"
      :clear-on-select="false"
      :options-limit="300"
      :max-height="600"
      :show-no-results="false"
      :hide-selected="true"
      @search-change="findAnnounceLuckydraw"
      :custom-label="customLabel"
    ></multiselect>

    <div v-if="selectCustomer">
      <table style="width: 100%" class="grey lighten-3 mt-4">
        <thead>
          <tr>
            <th>ชื่อ-นามสกุลของลูกค้า</th>
            <th>เลขที่ใบเสร็จ</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <!-- <template v-for="(customer, index) in filterCustomers">
            <tr :key="`customer_${index}`">
              <td>{{ customer.name }}</td>
              <td>{{ customer.receipt_no }}</td>
              <td class="text-xs-center">
                <v-btn small color="primary" @click="onAnnounce(customer)">
                  แจ้งผล
                </v-btn>
              </td>
            </tr>
          </template> -->

          <tr>
            <td>{{ selectCustomer.name }}</td>
            <td>{{ selectCustomer.receipt_no }}</td>
            <td class="text-xs-center">
              <v-btn small color="primary" @click="showConfirmAnnounce = true"> แจ้งผล </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <v-dialog v-model="showConfirmAnnounce" scrollable persistent max-width="800px">
      <v-card>
        <v-card-text>
          <div class="title primary--text mb-2">กรุณาเลือกของรางวัล</div>
          <v-layout>
            <v-flex class="px-1 default-input">
              <v-autocomplete
                v-model="selectedCategory"
                item-text="name"
                :items="categories"
                single-line
                outline
                placeholder="หมวดหมู่ของรางวัล"
                @change="onChangeCategory"
                return-object
              >
              </v-autocomplete>
            </v-flex>
            <v-flex class="px-1 default-input">
              <v-autocomplete
                v-model="selectedEcoupon"
                name="ecoupon"
                data-vv-as="ของรางวัล"
                :items="ecoupons"
                item-text="name"
                single-line
                outline
                placeholder="ของรางวัล"
                :disabled="!selectedCategory"
                :readonly="!selectedCategory"
                :loading="loadingReward"
                return-object
                v-validate="'required'"
                :error="errors.has(`ecoupon`) ? true : false"
                :error-messages="errors.has(`ecoupon`) ? errors.first(`ecoupon`) : ''"
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>

          <div class="title primary--text mb-2">กรุณากรอกข้อความแจ้งผล</div>

          <v-textarea
            v-model="announcement_message"
            name="announcement_message"
            data-vv-as="ข้อความแจ้งผล"
            outline
            single-line
            placeholder="กรุณากรอกข้อความแจ้งผล"
            counter="5000"
            maxlength="5000"
            v-validate="'max:5000'"
            :error="errors.has(`announcement_message`) ? true : false"
            :error-messages="
              errors.has(`announcement_message`) ? errors.first(`announcement_message`) : ''
            "
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="onAnnounce" color="primary">ตกลง</v-btn>
          <v-btn @click="showConfirmAnnounce = false">ยกเลิก</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template v-if="showHistory">
      <AnnounceLuckyHistory v-model="showHistory"></AnnounceLuckyHistory>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import AnnounceLuckyHistory from './AnnounceLuckyHistory'
import moment from 'moment'
export default {
  data() {
    return {
      selectCustomer: null,
      customers: [],
      filterCustomers: [
        {
          name: 'John',
          receipt_no: '1111',
          id: 0
        },
        {
          name: 'John',
          receipt_no: '1111',
          id: 0
        },
        {
          name: 'John',
          receipt_no: '1111',
          id: 0
        }
      ],
      search: '',
      loading: false,
      showHistory: false,
      showConfirmAnnounce: false,
      selectedCategory: null,
      categories: [],
      selectedEcoupon: null,
      ecoupons: [],
      announcement_message: '',
      loadingReward: false
    }
  },
  components: {
    Multiselect,
    AnnounceLuckyHistory
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  async mounted() {
    let categories = await this.getCategory()
    this.categories = categories
  },
  methods: {
    async onChangeCategory(val) {
      this.selectedcategory = val
      this.loadingReward = true
      let rewards = await this.getReward()
      rewards = rewards && rewards.data ? rewards.data : []
      this.ecoupons = rewards.filter((el) => {
        return moment().isBetween(el.effective_date, el.end_date) && el.quantity > 0
      })
      this.loadingReward = false
    },
    getReward() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          category_id: this.selectedcategory ? this.selectedcategory.id : '',
          campaign_id: this.selectedCampaign ? this.selectedCampaign.id : null
        }
        api.TOAECOUPONGetRewardProduct(data, (err, response) => {
          resolve({
            data: response.data,
            total: response.total
          })
        })
      })
    },
    getCategory() {
      if (!this.selectedCampaign) {
        return
      }
      return new Promise((resolve, reject) => {
        var data = {
          pageid: this.selectedBot.pageid,
          source: 'cms',
          campaignId: this.selectedCampaign ? this.selectedCampaign.id : null
        }
        api.TOAECOUPONGetRewardCategoryByCategoryId(data, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            resolve(response.data)
          }
          resolve([])
        })
      })
    },
    customLabel(item) {
      return item.name + ` (${item.receipt_no})`
    },
    async findAnnounceLuckydraw(search) {
      console.log(search)
      this.loading = true
      let data = {
        pageid: this.selectedBot.pageid,
        campaignid: this.selectedCampaign ? this.selectedCampaign.id : null,
        search: search,
        // receipt_no: this.receipt_no,
        type: 'customer'
      }
      let response = await api.findAnnounceLuckydraw(data)
      this.customers = response.data
      this.loading = false
    },
    async onAnnounce() {
      var result = await this.$validator.validateAll()

      if (!result) {
        this.goToErrorInput()
        return false
      }
      let data = {
        body: {
          pageid: this.selectedBot.pageid,
          campaignid: this.selectedCampaign ? this.selectedCampaign.id : null,
          userid: this.selectCustomer.userid,
          name: this.selectCustomer.name,
          receipt_no: this.selectCustomer.receipt_no,
          announcement_message: this.announcement_message, // ข้อความที่จะส่งไปให้ลูกค้า
          productid: this.selectedEcoupon ? this.selectedEcoupon.id : null // id ของสินค้าของรางวัล
        }
      }
      let response = await api.saveAnnouceLuckydraw(data)
      await this.$swal.fire({
        type: 'success',
        title: 'ระบบแจ้งผลไปยังลูกค้าเรียบร้อยแล้ว',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      this.showConfirmAnnounce = false
      this.selectedCategory = []
      this.selectedEcoupon = []
      this.announcement_message = ''
      this.selectCustomer = null

      // await this.$swal.fire({
      //   type: 'error',
      //   title: ' ไม่สามารถส่งข้อมูลไปยังลูกค้าท่านนี้ได้เนื่องจาก',
      //   confirmButtonText: this.$t('Confirm'),
      //   cancelButtonText: this.$t('cancel'),
      //   reverseButtons: true
      // })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/AnnounceLucky.vue